import React from 'react';
import classnames from 'classnames';

import WebformContainer, { type WebformContainerProps } from '../Container';

const WebformPage: React.FC<WebformContainerProps> = (props) => {
  const classes = classnames('WebformPage', {});

  return (
    <div className={classes}>
      <WebformContainer {...props} />
    </div>
  );
};

export default WebformPage;
